/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, ReactNode } from "react";
import { Tooltip } from "@material-ui/core";
import EwaButton2 from "src/components/atoms/inputs/EwaButtons/EwaButton/EwaButton2";
import { useRemoveErrorFromStackCallback } from "src/store/bugReport/useActions";
import { useServerPersonalizationData } from "src/store/personalization/useSelectors";
import { useBooleanState } from "../../../../hooks/utils";

import * as S from "./styles";
import { ReportBugButton } from "../../../atoms/inputs/EwaButtons";
import { useFormattedMsg } from "../../../../hooks/useFormatMsg";

export type SingleBugOverviewProps = {
  bugName: string;
  bugMessage: string;
  invokeBugModal: () => void;
  bugReported: boolean;
  stack?: string;
  componentStack?: string;
  index: number;
};

const SingleBugOverview: FC<SingleBugOverviewProps> = ({
  bugMessage,
  bugName,
  invokeBugModal,
  bugReported,
  stack,
  componentStack,
  index,
}) => {
  const [toggled, setToggled] = useBooleanState(false);
  const { bugReportVisible } = useServerPersonalizationData() ?? {};
  const removeErrorFromStack = useRemoveErrorFromStackCallback();
  const removeButtonTooltip = useFormattedMsg("bugs_overview.modal.remove");
  const tooltipTitle = useFormattedMsg("bugs_overview.modal.reported");

  const getBugReportSection = (): ReactNode => (
    <div css={S.bugReportButtonContainer}>
      {bugReportVisible &&
        (bugReported ? (
          <Tooltip title={tooltipTitle} placement="top-end">
            <S.IconCheck />
          </Tooltip>
        ) : (
          <ReportBugButton onClick={invokeBugModal} />
        ))}
      <EwaButton2
        iconName="close"
        tooltip={removeButtonTooltip}
        onClick={() => removeErrorFromStack(index)}
      />
    </div>
  );

  return (
    <div css={S.bugOverviewContainerCss}>
      <div css={S.bugOverviewRowCss}>
        <div css={S.bugOverviewRowCss}>
          <S.StyledArrowRight toggled={toggled} onClick={setToggled} />
          <div css={S.bugOverviewHeaderCss}>
            <span css={S.errorNameCss}>{bugName}</span>
            <div css={S.errorMessageWrapper}>
              <span css={S.errorMessageCss}>{bugMessage}</span>
            </div>
          </div>
        </div>
        {getBugReportSection()}
      </div>
      {(stack || componentStack) && (
        <S.BugOverviewContent toggled={toggled}>
          {stack && <p css={S.bugOverviewContentMessage}>{stack}</p>}
          {componentStack && (
            <p css={S.bugOverviewContentMessage}>{componentStack}</p>
          )}
        </S.BugOverviewContent>
      )}
    </div>
  );
};

export default SingleBugOverview;
